export default __webpack_public_path__ + "static/media/Resume1.80c0d1fb.png";